var _rect, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalTroGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.6 307.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.6,
    height: 307.76,
    ry: 44.816
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.319,
    cy: 60.73,
    r: 44.596,
    fill: "#666"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.659,
    cy: 155.22,
    r: 44.596,
    fill: "#666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1085.9 -266.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -1014.8,
    cy: 516.62,
    r: 44.596,
    fill: "none",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.34225 -3.9228)",
    fill: "#fff",
    strokeWidth: 3.1191
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1014.4 493.95-22.891 23.018c-1.7083 1.7195-4.4779 1.7195-6.1859 0-1.7081-1.7193-1.7081-4.5072 0-6.2269l25.765-25.906c0.9102-0.91628 2.1209-1.3286 3.3127-1.2684 1.1919-0.0603 2.4025 0.35206 3.3128 1.2684l25.765 25.906c1.7083 1.7196 1.7083 4.5073 0 6.2269-1.7082 1.7196-4.4777 1.7195-6.1856 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0,-1,-1,0,0,0)",
    x: -557.53,
    y: 1009.9,
    width: 56.38,
    height: 9.0781,
    ry: 4.5391
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalTroGreen);
export default __webpack_public_path__ + "static/media/signal_tro_green.44bba158587e1c735fb2712a32b497a8.svg";
export { ForwardRef as ReactComponent };